var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 7.144a7.08 7.08 0 0 1-4.112-1.303v5.935c0 1.1-.34 2.173-.971 3.076a5.44 5.44 0 0 1-2.565 1.979 5.5 5.5 0 0 1-3.245.177 5.45 5.45 0 0 1-2.769-1.689 5.36 5.36 0 0 1-.682-6.115 5.42 5.42 0 0 1 2.33-2.246 5.5 5.5 0 0 1 3.206-.531v2.985a2.52 2.52 0 0 0-1.542.014c-.5.165-.934.483-1.24.908a2.46 2.46 0 0 0 .017 2.909c.311.42.75.733 1.25.893.502.16 1.042.158 1.543-.004.5-.163.936-.478 1.245-.901s.476-.932.476-1.455V.173h2.947q-.003.371.063.736a4 4 0 0 0 .625 1.517c.31.458.712.849 1.18 1.148A4.1 4.1 0 0 0 15 4.242z"
  })));
};
export default SvgTiktok;